import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const ThankYou = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="text-center">
      <bootstrap.Container>
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="fw-bold py-4">{t("thankYou.thankYou")}</h2>
            <bootstrap.Card>
              <bootstrap.Card.Body>
                <p className="lead py-2">
                  {t("thankYou.registrationID")} {location.state.id}
                </p>
                <p className="lead py-2">{t("thankYou.message1")}</p>
                <p className="lead py-1">{t("thankYou.message2")}</p>

                {location.state.country === "US" && (
                  <div>
                    <p className="lead py-1">{t("thankYou.message3")}</p>
                  </div>
                )}
                {location.state.country === "CA" && (
                  <div>
                    <p className="lead py-1">{t("thankYou.message4")}</p>
                  </div>
                )}
                <p className="lead fw-bold py-1">{t("thankYou.message5")}</p>
              </bootstrap.Card.Body>
            </bootstrap.Card>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
